/*
 * <click-to-play-video> — toont een cover met play-knop. Bij klik speelt de
 * video af met geluid en verschijnen de native controls. Bij pauze of einde
 * verdwijnen de controls weer en komt de play-knop terug.
 * Gebruikt door de image-with-text sectie (optie "klik om af te spelen met geluid").
 */
if (!customElements.get('click-to-play-video')) {
  class ClickToPlayVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('.image-with-text__ctp-play');
      if (!this.video) return;

      const showControls = () => {
        this.video.controls = true;
        this.setAttribute('playing', '');
      };
      const hideControls = () => {
        this.video.controls = false;
        this.removeAttribute('playing');
      };

      if (this.playButton) {
        this.playButton.addEventListener('click', () => {
          const playPromise = this.video.play();
          if (playPromise) playPromise.catch(() => {});
        });
      }
      this.video.addEventListener('play', showControls);
      this.video.addEventListener('pause', hideControls);
      this.video.addEventListener('ended', hideControls);
    }
  }
  customElements.define('click-to-play-video', ClickToPlayVideo);
}
